// extracted by mini-css-extract-plugin
export default {"skillsSection":"Skills_skillsSection__Q2Aeg","skillsContainer":"Skills_skillsContainer__ScH+C","heading":"Skills_heading__Fue6f"};